export default "__VITE_ASSET__OZU6iv0x__"